import React from 'react';
import PropTypes from 'prop-types';
import Datetime from 'react-datetime';
import Moment from 'moment';
import imgCal from '../../assets/images/calendar.png';

import './styles.css';

const FilterDropDown = ({
  inputId,
  onChange,
  min,
  max,
  selected,
}) => (
  <Datetime
    value={Moment(selected).format('MMM D, YYYY')}
    onChange={onChange}
    timeFormat={false}
    dateFormat="MMM D, YYYY"
    isValidDate={current => current.isBetween(min, max, 'day', '[]')}
    renderInput={(props, openCalendar) => (
      <div styleName="filter">
        <input
          {...props}
          id={inputId}
          styleName="filterDateSelect"
          onClick={openCalendar}
          readOnly
        />
        <img
          styleName="filterCal"
          src={imgCal}
          alt="arrow"
        />
      </div>
    )}
  />
);

const FilterDateRange = ({
  onFromChange,
  min,
  fromSelected,
  onToChange,
  max,
  toSelected,
}) => (
  <div styleName="filterGroup">
    <div styleName="filterGroup">
      <div styleName="filterLabel">From Date</div>
      <FilterDropDown
        inputId="fromDateFilter"
        onChange={onFromChange}
        min={min}
        max={max}
        selected={fromSelected}
      />
    </div>
    <div styleName="filterLabel">To Date</div>
    <FilterDropDown
      inputId="toDateFilter"
      onChange={onToChange}
      min={min}
      max={max}
      selected={toSelected}
    />
  </div>
);

FilterDateRange.propTypes = {
  onFromChange: PropTypes.func,
  fromSelected: PropTypes.string,
  min: PropTypes.string,
  onToChange: PropTypes.func,
  toSelected: PropTypes.string,
  max: PropTypes.string,
};

FilterDateRange.defaultProps = {
  onFromChange: () => {},
  fromSelected: '',
  min: '',
  onToChange: () => {},
  toSelected: '',
  max: '',
};

export default FilterDateRange;



// WEBPACK FOOTER //
// ./src/components/BaseFilteredList/FilterDateRange.js